import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Auth pages
import LoginPage from "./pages/LoginPage";
import AboutUs from "./pages/AboutUs";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import RegisterPage from "./pages/RegisterPage";
import ForgotPassword from "./components/Auth/ForgotPassword";
import ResetPassword from "./components/Auth/ResetPassword";

// Owner pages
import OwnerDashboard from "./owner/pages/OwnerDashboard";
import OwnerProfile from "./owner/pages/OwnerProfile";
import ReportFraud from "./owner/pages/ReportFraud";
import RegisteredFrauds from "./owner/pages/RegisteredFrauds";
import OwnerNotifications from "./owner/pages/OwnerNotifications";
import OwnerSubscription from "./owner/pages/OwnerSubscription";

// Admin pages
import AdminDashboard from "./admin/pages/Dashboard";
import AdminFrauds from "./admin/pages/AdminFrauds";
import AdminFraudDetails from "./admin/pages/AdminFraudDetails";
import AdminOwners from "./admin/pages/AdminOwners";
import AdminOwnerDetails from "./admin/pages/AdminOwnerDetails";
import AdminProfile from "./admin/pages/AdminProfile";
import AdminLogin from "./admin/pages/AdminLogin";
import AdminAlerts from "./admin/pages/AdminAlerts";
import AdminSubscriptions from "./admin/pages/AdminSubscriptions";
import AdminPlans from "./admin/pages/AdminPlans";
import AdminSettings    from "./admin/pages/AdminSettings";
import AdminInvoices    from "./admin/pages/AdminInvoices";

import OwnerActivityLogs  from "./owner/pages/OwnerActivityLogs";
import AdminActivityLogs  from "./admin/pages/AdminActivityLogs";
//import BulkImport from "./owner/pages/BulkImport";
import AdminAnalytics from "./admin/pages/AdminAnalytics";

// ✅ Route Guards
import ProtectedOwnerRoute from "./components/ProtectedOwnerRoute";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/admin/plans" element={<AdminPlans />} />
        <Route path="/admin/settings" element={<AdminSettings />} />


        {/* Admin login is public */}
        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* ✅ OWNER routes — only logged-in owners can access */}
        <Route path="/owner/dashboard" element={
          <ProtectedOwnerRoute><OwnerDashboard /></ProtectedOwnerRoute>
        } />
        <Route path="/owner/profile" element={
          <ProtectedOwnerRoute><OwnerProfile /></ProtectedOwnerRoute>
        } />
        <Route path="/owner/report-fraud" element={
          <ProtectedOwnerRoute><ReportFraud /></ProtectedOwnerRoute>
        } />
        <Route path="/owner/registered-frauds" element={
          <ProtectedOwnerRoute><RegisteredFrauds /></ProtectedOwnerRoute>
        } />
        <Route path="/owner/notifications" element={
          <ProtectedOwnerRoute><OwnerNotifications /></ProtectedOwnerRoute>
        } />
        <Route path="/owner/subscription" element={
          <ProtectedOwnerRoute><OwnerSubscription /></ProtectedOwnerRoute>
        } />

        {/* ✅ ADMIN routes — only logged-in admins can access */}
        <Route path="/admin/dashboard" element={
          <ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>
        } />
        <Route path="/admin/frauds" element={
          <ProtectedAdminRoute><AdminFrauds /></ProtectedAdminRoute>
        } />
        <Route path="/admin/frauds/:fraudId" element={
          <ProtectedAdminRoute><AdminFraudDetails /></ProtectedAdminRoute>
        } />
        <Route path="/admin/owners" element={
          <ProtectedAdminRoute><AdminOwners /></ProtectedAdminRoute>
        } />
        <Route path="/admin/owners/:id" element={
          <ProtectedAdminRoute><AdminOwnerDetails /></ProtectedAdminRoute>
        } />
        <Route path="/admin/profile" element={
          <ProtectedAdminRoute><AdminProfile /></ProtectedAdminRoute>
        } />
        <Route path="/admin/alerts" element={
          <ProtectedAdminRoute><AdminAlerts /></ProtectedAdminRoute>
        } />
        <Route path="/admin/subscriptions" element={
          <ProtectedAdminRoute><AdminSubscriptions /></ProtectedAdminRoute>
        } />

        <Route path="/owner/logs"  element={<ProtectedOwnerRoute><OwnerActivityLogs /></ProtectedOwnerRoute>} />
        <Route path="/admin/logs"  element={<AdminActivityLogs />} />
       {/* Bulk Import — temporarily hidden
<Route path="/owner/bulk-import" element={<BulkImport />} />
*/}
        <Route path="/admin/analytics" element={<AdminAnalytics />} />
        <Route path="/admin/invoices"  element={<ProtectedAdminRoute><AdminInvoices /></ProtectedAdminRoute>} />
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;